import * as api from "@/api/williams/scopesOfWork";
import { useQuery } from "react-query";

export function useDefaultScope() {
  return useQuery("default-scope", api.getDefaultValues, {
    cacheTime: 0,
    staleTime: 0,
  });
}
